import loadable from '@loadable/component';

import { Outlet } from 'react-router-dom';
import { routes as authRoutes } from './app/auth/routes.tsx';
import NoAccessPage from './app/no-access/page.tsx';
import { AuthenticatedUserWrapper } from './authenticated-user/authenticated-user-wrapper.tsx';
import { AuthProvider } from './authenticated-user/authProvider'; // Make sure the import path is correct
import ForgotPassword from './authenticated-user/pages/forgot-password/forgot-password.tsx';
import { LoginPage } from './authenticated-user/pages/login/login.tsx';
import AuthCallbackPage from './authenticated-user/pages/auth-callback/auth-callback.tsx';
import Register from './authenticated-user/pages/sign-up/sign-up.tsx';

const AuthLayout = loadable(() => import('./app/auth/layout.tsx'), {
  resolveComponent: (components) => components.Layout,
});

const NotFoundPage = loadable(() => import('./app/not-found/page.tsx'));

export const RootLayout = () => {
  return <Outlet />;
};

export const baseRouter = [
  {
    path: 'login',
    element: (
      <AuthProvider>
        <LoginPage />
      </AuthProvider>
    ),
  },
  {
    path: 'auth/callback',
    element: (
      <AuthProvider>
        <AuthCallbackPage />
      </AuthProvider>
    ),
  },
  {
    path: 'forgot-password',
    element: (
      <AuthProvider>
        <ForgotPassword />
      </AuthProvider>
    ),
  },
  {
    path: 'sign-up',
    element: (
      <AuthProvider>
        <Register />
      </AuthProvider>
    ),
  },
  {
    path: 'no-access',
    element: (
      <AuthProvider>
        <NoAccessPage />
      </AuthProvider>
    ),
  },
  {
    path: '/',
    element: (
      <AuthProvider>
        <AuthenticatedUserWrapper>
          <RootLayout />
        </AuthenticatedUserWrapper>
      </AuthProvider>
    ),
    children: [
      {
        path: '/',
        element: <AuthLayout />,
        children: authRoutes,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];
